import './utils/suppressWarnings'; // Must be first
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

// Initialize theme
const initialTheme = localStorage.getItem('color-theme') ||
  (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
document.documentElement.classList.remove('dark', 'grey');
if (initialTheme !== 'light') {
  document.documentElement.classList.add(initialTheme);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
